import { aboutInfo } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          关于丫丫
        </h2>
        <div className="max-w-2xl">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-3">
            {aboutInfo.content}
          </p>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {aboutInfo.content2}
          </p>
        </div>
      </div>
    </section>
  );
}